/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_New_ChatInputs */

const es_sidebar_new_chat = /** @type {(inputs: Sidebar_New_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo Chat`)
};

const en_sidebar_new_chat = /** @type {(inputs: Sidebar_New_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Chat`)
};

/**
* | output |
* | --- |
* | "New Chat" |
*
* @param {Sidebar_New_ChatInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_new_chat = /** @type {((inputs?: Sidebar_New_ChatInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_New_ChatInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_new_chat(inputs)
	return en_sidebar_new_chat(inputs)
});
export { sidebar_new_chat as "sidebar.new_chat" }